import React, { FC } from 'react';
import { RichMarkdownIt } from '../../RichMarkdownIt';

import './FormAlert.scss';

interface Props {
  readonly type: 'error' | 'info' | 'success' | 'warning';
  readonly markdown: string;
}

export const FormAlert: FC<Props> = ({ type, markdown }) => {
  return (
    <div className={`form-alert-${type} form-alert`}>
      <RichMarkdownIt source={markdown} />
    </div>
  );
};
